// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:35:37.771Z
// Property: Trails at Aspen Creek (ID: 6767906449165638)
// Collections: 25 amenities, 12 floorplans (live), 39 photos, 57 POIs, 5 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165638",
  "property_external_id": "ltfkyve",
  "property_zillow_url": "https://www.zillow.com/apartments/broken-arrow-ok/trails-at-aspen-creek/CgrJHT/",
  "property_apartments_url": "https://www.apartments.com/trails-at-aspen-creek-broken-arrow-ok/ltfkyve/",
  "property_google_business_url": "https://www.google.com/maps/place/Trails+at+Aspen+Creek+Apartments/data=!4m2!3m1!1s0x0:0xd73a272884f0f5bd?sa=X&ved=2ahUKEwjD-vT5gb2SAxU478kDHSziBbQQ_BJ6BAgKEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "trails-at-aspen-creek",
  "property_name": "Trails at Aspen Creek",
  "property_website_url": "https://www.caseusa.com/apartments/ok/broken-arrow/trails-at-aspen-creek/",
  "property_domain": null,
  "property_address": "2602 W. Tucson St.",
  "property_full_address": "2602 W. Tucson St., Broken  Arrow, OK, 74011",
  "property_address_1": "2602 W. Tucson St.",
  "property_address_2": null,
  "property_address_city": "Broken  Arrow",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74011",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "35.989",
  "property_address_longitude": "-95.8214",
  "property_email": "trailsataspencreek@caseusa.com",
  "property_phone": "5392164362",
  "property_call_tracking_phone": "833-755-0210",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Trails at Aspen Creek in Broken Arrow, where modern comfort meets nature's tranquility. Choose from spacious one, two, or three-bedroom floor plans, and enjoy premium amenities like a serene pool, fitness center, and dog park. Your ideal home, complete with inviting spaces, awaits—let's connect! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Trails at Aspen Creek, your premier apartment community located in the heart of Broken Arrow, Oklahoma! Our thoughtfully designed floor plans include generous one, two, and three-bedroom options, ensuring you’ll find the perfect space to call home. Each apartment features modern amenities such as high-speed internet access, spacious walk-in closets, and stainless steel appliances to enhance your living experience. Enjoy the luxury of having your own washer and dryer, air conditioning, and cozy fireplaces that add warmth to those chilly evenings.\n\nAt Trails at Aspen Creek, we prioritize your comfort and leisure with an array of outstanding amenities. Dive into our sparkling pool or stay fit year-round in our state-of-the-art fitness center. Our beautifully landscaped grounds feature walking and biking trails, a dog park, and serene picnic areas, perfect for enjoying the great outdoors. Socialize in our inviting clubhouse or get work done in the on-site business center, all while benefiting from our dedicated maintenance and property management team.\n\nSafety and convenience are paramount here, with gated access and multiple online services to simplify your life. Experience the beauty of nature and community in our lush courtyard and spacious sun deck, designed for relaxation and enjoyment. \n\nWith a variety of apartments available, Trails at Aspen Creek is the ideal destination for anyone seeking a vibrant and welcoming community. Don't wait—find your new home today! Browse our availability or schedule a tour to visit our wonderful community and discover your perfect apartment living experience.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-bec2-73d6-a335-03506a514ad0.webp",
  "property_featured_image_media": {
    "alt_text": "Resort-style swimming pool and lounge area with apartment buildings in the background.",
    "public_id": "019cfb4c-bec2-73d6-a335-03506a514ad0",
    "storage_key": "property/6767906449165638/019cfb4c-bec2-73d6-a335-03506a514ad0.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "365",
  "property_year_built": "2024",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98.35616438356163",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum 2 pets allowed (cats and dogs). Breed restrictions apply.",
  "property_pet_policy_description": "No weight limit. Maximum 2 pets allowed (cats and dogs). Breed restrictions apply. Pet fee: $500 per pet (non‑refundable). Monthly pet rent: $30 per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://trailsataspencreekapartmentsbrokenarrow.securecafe.com/onlineleasing/trails-at-aspen-creek/floorplans.aspx",
  "property_resident_portal_url": "https://trailsataspencreekapartmentsbrokenarrow.securecafe.com/residentservices/trails-at-aspen-creek/userlogin.aspx",
  "property_apply_now_url": "https://trailsataspencreekapartmentsbrokenarrow.securecafe.com/onlineleasing/trails-at-aspen-creek/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-5386-741a-9ac9-e94765f46fe2.webp",
  "property_primary_logo_media": {
    "alt_text": "The Trails at Aspen Creek logo.",
    "public_id": "019cfb4b-5386-741a-9ac9-e94765f46fe2",
    "storage_key": "property/6767906449165638/019cfb4b-5386-741a-9ac9-e94765f46fe2.webp",
    "width": 1200,
    "height": 692
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-b53d-7718-ab0b-617a018a1bb0.webp",
  "property_secondary_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb4c-b53d-7718-ab0b-617a018a1bb0",
    "storage_key": "property/6767906449165638/019cfb4c-b53d-7718-ab0b-617a018a1bb0.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-cfed-71e8-9063-576176a61ec9.webp",
  "property_mono_white_logo_media": {
    "alt_text": "The Trails at Aspen Creek logo with a winding path.",
    "public_id": "019cfb4c-cfed-71e8-9063-576176a61ec9",
    "storage_key": "property/6767906449165638/019cfb4c-cfed-71e8-9063-576176a61ec9.webp",
    "width": 640,
    "height": 369
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-dce4-7399-964e-552cd0ee8957.webp",
  "property_mono_black_logo_media": {
    "alt_text": "The Trails at Aspen Creek logo",
    "public_id": "019cfb4c-dce4-7399-964e-552cd0ee8957",
    "storage_key": "property/6767906449165638/019cfb4c-dce4-7399-964e-552cd0ee8957.webp",
    "width": 640,
    "height": 369
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#daba6b",
  "property_secondary_color": "#4c5747",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#504942",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 3",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "789 - 1435",
  "property_sqft_min": "789",
  "property_sqft_max": "1435",
  "property_price_range": "1194 - 2179",
  "property_price_min": "1194",
  "property_price_max": "2179",
  "property_available_units": 9,
  "property_facebook_url": "https://www.facebook.com/TrailsatAspenCreekBA",
  "property_instagram_url": "https://www.instagram.com/trailsataspencreekba/?hl=en",
  "property_twitter_url": "https://x.com/CaseAssociateOK",
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJcysGSLyPtocRvfXwhCgnOtc",
  "property_youtube_url": "https://www.youtube.com/watch?v=bynUMjQAOec&t=111",
  "property_yelp_url": "https://www.yelp.com/search?cflt=apartments&find_loc=Broken+Arrow%2C+OK",
  "property_tiktok_url": "https://www.tiktok.com/discover/dream-aspen-creek-apartments-broken-arrow",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Trails at Aspen Creek",
  "property_home_romance_title": "Embrace Your New Life at Our Vibrant Apartment Community",
  "property_home_amenities_blurb": "Welcome to Trails at Aspen Creek in Broken Arrow, Oklahoma, where comfort meets convenience. Choose from spacious one, two, or three-bedroom layouts, and indulge in our onsite amenities, including a refreshing pool, a fully equipped fitness center, and scenic walking trails. Your perfect home awaits!",
  "property_home_floorplans_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, your dream apartment awaits! Choose from spacious one, two, or three-bedroom floor plans that perfectly fit your lifestyle. Embrace a welcoming community ambiance, scenic views, and modern amenities. Browse our available homes today and find your ideal living space!",
  "property_home_gallery_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, you'll find a perfect blend of modern comfort and nature-inspired living. Choose from spacious one, two, or three-bedroom floor plans while enjoying amenities like a refreshing pool, inviting clubhouse, and serene walking trails. Picture yourself living here, where every detail enhances your lifestyle!",
  "property_home_neighborhood_blurb": "Nestled in the heart of Broken Arrow, Oklahoma, Trails at Aspen Creek offers a variety of thoughtfully designed floor plans, including one, two, and three-bedroom apartments. Immerse yourself in a vibrant neighborhood filled with local favorites and hidden gems. Uncover the possibilities just steps from your new home!",
  "property_home_reviews_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, residents rave about the community's welcoming atmosphere, highlighting it as “the perfect blend of comfort and convenience.” Experience a vibrant lifestyle surrounded by beautiful landscapes and modern amenities. Curious about life here? See what our residents have to say!",
  "property_neighborhood_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, your home is surrounded by educational excellence. With enticing options like Tulsa C.C. Southeast Campus and Oral Roberts University nearby, your learning journey is easily within reach. Uncover enriching experiences and local gems that elevate your lifestyle—your adventure awaits!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, comfort meets adventure. Choose from stylish one, two, or three-bedroom layouts, and enjoy resort-style amenities including a sparkling pool, a well-equipped fitness center, and scenic walking trails. Experience elevated living with modern features tailored for your lifestyle.",
  "property_applynow_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, your ideal home awaits. Choose from spacious one, two, or three-bedroom floor plans designed for comfort. Enjoy amenities like a refreshing pool, state-of-the-art fitness center, and a welcoming dog park. Embrace a vibrant lifestyle—lease online today and make it yours!",
  "property_contactus_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, our thoughtfully designed apartments offer one, two, and three-bedroom floor plans to fit your lifestyle. With spacious layouts and modern amenities, you’re just a call away from your perfect home. Have questions? Contact our leasing team today!",
  "property_faqs_blurb": "Nestled in Broken Arrow, Oklahoma, Trails at Aspen Creek offers thoughtfully designed one, two, and three-bedroom apartments tailored to your lifestyle. Curious about community amenities, pet policies, or lease terms? Navigate through our comprehensive FAQs page to uncover all you need to know about your future home!",
  "property_floorplans_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, your dream apartment awaits. Choose from thoughtfully designed one, two, or three-bedroom floor plans tailored for comfort and style. Each layout enhances your living experience. Browse our available options and find the perfect space to call home today!",
  "property_gallery_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, vibrant living awaits. From our stylish one to three-bedroom apartments, amenities like a refreshing pool and a serene dog park create an unmatched lifestyle. Picture yourself enjoying the sundeck or relaxing in the clubhouse—home is truly where the heart is!",
  "property_interactivemap_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, your perfect living space awaits—whether it’s a cozy one-bedroom or a spacious three-bedroom. Enjoy resort-style amenities like a sparkling pool, state-of-the-art fitness center, and serene walking trails. Check out our interactive community map to find your ideal apartment today!",
  "property_pets_blurb": "At Trails at Aspen Creek in Broken Arrow, OK, your furry friends are part of the family! Enjoy a pet-friendly lifestyle with no weight limits and space for two pets. Make memories in our vibrant community while your pets play and thrive in a welcoming environment tailored for all.",
  "property_referafriend_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, your ideal living space awaits—whether it’s a cozy one-bedroom or a spacious three-bedroom. Great friends make great neighbors, so refer a friend today and create a vibrant community together! Check out our diverse floor plans and start your next chapter.",
  "property_residentaccess_blurb": "Welcome to Trails at Aspen Creek in Broken Arrow, Oklahoma, where our thoughtfully designed one, two, and three-bedroom floor plans cater to your lifestyle. Seamlessly manage your living experience—access your resident portal today for rent payments, maintenance requests, and more! Embrace the convenience of modern living right at your fingertips.",
  "property_reviews_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, residents rave about the welcoming atmosphere, stating it's \"the perfect blend of comfort and community.\" Join our vibrant neighborhood and experience a lifestyle that prioritizes your happiness. See what our residents have to say about living at our community!",
  "property_created_at": "1753982395781",
  "property_scheduletour_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, find your perfect home with our thoughtfully designed one, two, and three-bedroom floor plans. Embrace vibrant living in a welcoming community. Ready for a closer look? Schedule a tour today and hear firsthand how our residents cherish their experience here!",
  "property_thankyou_blurb": "Thank you for reaching out! At Trails at Aspen Creek in Broken Arrow, we offer thoughtfully designed floor plans, including one, two, and three-bedroom options. Each home blends comfort and style, tailored for your lifestyle. A team member will connect with you shortly to help you find your perfect fit!",
  "property_virtualtours_blurb": "At Trails at Aspen Creek in Broken Arrow, Oklahoma, our thoughtfully designed one, two, and three-bedroom floor plans cater to every lifestyle. Each residence offers modern amenities and inviting spaces. Ready to find your perfect home? Immerse yourself in a virtual tour of our vibrant community and available apartments today!",
  "property_copyright": "2025 All Rights Reserved. Trails at Aspen Creek",
  "property_seo_title_home": "Trails at Aspen Creek | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_home": "Experience modern living at Trails at Aspen Creek in Broken Arrow, OK. Choose from spacious one, two, or three-bedroom apartments with top-notch amenities. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | 1 - 3 Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_floorplans": "Find your ideal home at Trails at Aspen Creek in Broken Arrow, OK. Choose from spacious one, two, and three-bedroom floor plans tailored for your lifestyle.",
  "property_seo_title_amenities": "Amenities | Broken Arrow, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Unwind at Trails at Aspen Creek in Broken Arrow! Enjoy top amenities like a pool, fitness center, dog park, and stylish apartments. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_gallery": "Experience life at Trails at Aspen Creek in Broken Arrow, OK. Enjoy spacious floor plans, top-notch amenities, and picturesque views. Picture your new home today!",
  "property_seo_title_virtualtours": "Virtual Tours | Trails at Aspen Creek Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Trails at Aspen Creek in Broken Arrow! Take a virtual tour of our spacious one, two, and three-bedroom apartments today!",
  "property_seo_title_interactivemap": "Interactive Map | Trails at Aspen Creek Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Trails at Aspen Creek in Broken Arrow! Enjoy spacious 1-3 bedroom apartments, resort-style amenities, and a vibrant community map to guide your journey.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the charm of Broken Arrow at Trails at Aspen Creek. Dive into local favorites and explore ideal hotspots just steps from your new home!",
  "property_seo_title_contact": "Contact Us | Trails at Aspen Creek",
  "property_seo_description_contact": "Connect with Trails at Aspen Creek in Broken Arrow, OK! Whether you're seeking a cozy 1-bedroom or spacious 3-bedroom, our leasing team is here to help.",
  "property_seo_title_faqs": "FAQs | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_faqs": "\"Got questions about life at Trails at Aspen Creek? Dive into our FAQs for insights on amenities, floor plans, and what makes our Broken Arrow community shine!\"",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_reviews": "\"Experience life at Trails at Aspen Creek in Broken Arrow—where vibrant amenities meet spacious floor plans. Check out authentic resident reviews today!\"",
  "property_seo_title_applynow": "Apply Now | Apartments in Broken Arrow, Oklahoma",
  "property_seo_description_applynow": "Experience modern living at Trails at Aspen Creek in Broken Arrow! Choose from one to three-bedroom apartments with top-notch amenities. Lease online today!",
  "property_seo_title_residentaccess": "Resident Access | Trails at Aspen Creek",
  "property_seo_description_residentaccess": "Unlock your resident portal at Trails at Aspen Creek! Manage rent, maintenance requests, and connect with your community—all from the comfort of home.",
  "property_seo_title_referafriend": "Refer A Friend | Trails at Aspen Creek",
  "property_seo_description_referafriend": "Share the love at Trails at Aspen Creek! Refer a friend to our Broken Arrow community and enjoy special rewards together. Great friends, great neighbors!",
  "property_seo_title_scheduletour": "Schedule a Tour | Trails at Aspen Creek",
  "property_seo_description_scheduletour": "Experience modern living at Trails at Aspen Creek in Broken Arrow. Schedule a tour today and see your future home nestled in nature's beauty!",
  "property_seo_title_privacy": "Privacy Policy | Trails at Aspen Creek",
  "property_seo_description_privacy": "Safeguarding your peace of mind at Trails at Aspen Creek in Broken Arrow. Review our privacy policy to learn how we protect your information.",
  "property_seo_title_accessibility": "Website Accessibility | Trails at Aspen Creek",
  "property_seo_description_accessibility": "At Trails at Aspen Creek in Broken Arrow, we embrace accessibility for all. Join our community where everyone feels at home—experience inclusive living today!",
  "property_seo_title_sitemap": "Sitemap | Trails at Aspen Creek",
  "property_seo_description_sitemap": "Navigate your way to your ideal home at Trails at Aspen Creek in Broken Arrow, OK! Find easy access to features, amenities, and community info with our sitemap.",
  "property_seo_title_thankyou": "Thank You | Trails at Aspen Creek",
  "property_seo_description_thankyou": "Thank you for reaching out to Trails at Aspen Creek in Broken Arrow! Our team will be in touch soon to help you find your perfect home. Stay tuned!",
  "property_seo_title_pets": "Pet Policy | Apartments in Broken  Arrow, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787866037520",
  "amenities": [
    {
      "id": "ec_6d2a8b43b62f9510efc13f9c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397352",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5bd584cea14bdd4b37b54b0d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397353",
      "title": "Clubhouse w/ Billiards",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2809dda0f3a2a027fcd60ddf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397354",
      "title": "Limited Access Gates",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7a650a43a23ddac2b3c69aba",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397355",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c837bb805662deb9af80b389",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397356",
      "title": "24-Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f4505213367552f597de2f00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397357",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fff8e216074f93d96ace34fd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397358",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0d122a375d29110e0d9934dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397359",
      "title": "Attached* & Detached Garages Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a868079dd0715c731cb41014",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397360",
      "title": "Resort-Style Pool with Sun Deck",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fa2815deed278b9f0176e27c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397361",
      "title": "Fire Pit",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4946c54854b0b11dfe921d62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397362",
      "title": "Onsite Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc85847ea37aad98ad6996dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397363",
      "title": "Picnic Areas",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fe9dafcaf9d7c8788d40e8e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127397364",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_045cc93e788dd3fac6333ac5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "128017318",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5175b343d45581e96cd16c4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "128042558",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07b43ef9b5f85d60ec1115dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398804",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fd807c5379aa72de69d4afcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398805",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_002d50067c65def35971e6f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398806",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b4e8492c2ab8a6794fabab0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398807",
      "title": "Central Heat & Air",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc7652d312cccbe3027a1ba7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398808",
      "title": "Fireplaces*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_679fa7983a9569f033df8092",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398809",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ddcab6a70d18e9257d71533",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398810",
      "title": "Choice of Townhome, Loft, or Apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_94bc75861d999ece7b9a91d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398811",
      "title": "Private Patio or Balcony*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_abfb3da4d6b5f7d32b03c71a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398812",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eda9971833ccc397807dccc1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "yardi",
      "external_id": "127398813",
      "title": "Walk-In Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4935b446-0772-41b1-a4f6-a9e488065dde",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-3c77-730e-b423-7936ddfd72c0.webp",
      "image_media": {
        "alt_text": "Front entrance sign for The Trails at Aspen Creek Apartments on a green lawn with a white fence.",
        "public_id": "019d20b0-3c77-730e-b423-7936ddfd72c0",
        "storage_key": "property/6767906449165638/019d20b0-3c77-730e-b423-7936ddfd72c0.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Entrance sign for The Trails at Aspen Creek Apartments, with landscaping and nearby residential buildings in the background.",
      "link": "",
      "alt_text": "Front entrance sign for The Trails at Aspen Creek Apartments on a green lawn with a white fence.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165638/019cfb4b-537c-77d2-abb6-430cc1f53693.webp"
    },
    {
      "id": "custom_4f5c3331-85db-4e4e-85e5-4e75464c6040",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-3c8f-7179-9592-24671c10fb85.webp",
      "image_media": {
        "alt_text": "Outdoor community barbecue area with brick counters, two grills, and a picnic table.",
        "public_id": "019d20b0-3c8f-7179-9592-24671c10fb85",
        "storage_key": "property/6767906449165638/019d20b0-3c8f-7179-9592-24671c10fb85.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Shared outdoor grilling area for residents with brick counters, two grills, and a picnic table.",
      "link": "",
      "alt_text": "Outdoor community barbecue area with brick counters, two grills, and a picnic table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165638/019cfb4b-5ca5-774f-8fad-35339b5f665d.webp"
    },
    {
      "id": "custom_81b6923d-9926-408d-873a-6fc1992e6e55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-3bce-772d-bb25-ec2a07df0fc2.webp",
      "image_media": {
        "alt_text": "Outdoor pool at a multi-family apartment community with lounge chairs and umbrellas.",
        "public_id": "019d20b0-3bce-772d-bb25-ec2a07df0fc2",
        "storage_key": "property/6767906449165638/019d20b0-3bce-772d-bb25-ec2a07df0fc2.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Resort-style pool area within a modern apartment community, featuring lounge seating and shaded umbrellas.",
      "link": "",
      "alt_text": "Outdoor pool at a multi-family apartment community with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto/property/6767906449165638/019cfb4b-5cda-75b9-9605-986a283a677b.webp"
    },
    {
      "id": "custom_66772ff5-9199-427f-916e-a6009979d110",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-3b17-74cc-a5da-2960d30b2aef.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern apartment community entrance with glass doors and stone façade.",
        "public_id": "019d20b0-3b17-74cc-a5da-2960d30b2aef",
        "storage_key": "property/6767906449165638/019d20b0-3b17-74cc-a5da-2960d30b2aef.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Entrance to the apartment community featuring a modern façade, glass doors, stone accents, and a wide concrete plaza.",
      "link": "",
      "alt_text": "Exterior view of a modern apartment community entrance with glass doors and stone façade.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-071e-709f-a4bd-3d3e7c1a9aaa.webp"
    },
    {
      "id": "custom_38ca7ab7-8d2c-4070-8887-0ab8ecc97bea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-45aa-745e-b413-4c917aa34623.webp",
      "image_media": {
        "alt_text": "Modern apartment lobby with green sofas and a sign reading 'The Trails at Aspen Creek'.",
        "public_id": "019d20b0-45aa-745e-b413-4c917aa34623",
        "storage_key": "property/6767906449165638/019d20b0-45aa-745e-b413-4c917aa34623.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright, open community lobby with contemporary furnishings and a welcoming entry at The Trails at Aspen Creek.",
      "link": "",
      "alt_text": "Modern apartment lobby with green sofas and a sign reading 'The Trails at Aspen Creek'.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-d122-74e4-b1e1-1a621b7a9769.webp"
    },
    {
      "id": "custom_5a22306f-60dd-40c1-bd5a-3339775f2c56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-4679-70ca-82b4-fc99af165f88.webp",
      "image_media": {
        "alt_text": "Spacious modern apartment lobby with two green sofas facing a stone fireplace and open entryways.",
        "public_id": "019d20b0-4679-70ca-82b4-fc99af165f88",
        "storage_key": "property/6767906449165638/019d20b0-4679-70ca-82b4-fc99af165f88.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Bright, contemporary lobby with comfortable seating, a stone fireplace, and open passages to adjacent amenity spaces.",
      "link": "",
      "alt_text": "Spacious modern apartment lobby with two green sofas facing a stone fireplace and open entryways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-e7c8-77a7-ad41-f3b25622b08e.webp"
    },
    {
      "id": "custom_125c6549-0462-4f2d-aedd-0f8577396769",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-481b-734f-b922-d5017aa66935.webp",
      "image_media": {
        "alt_text": "Billiard table in a stylish lounge area with large windows overlooking the pool.",
        "public_id": "019d20b0-481b-734f-b922-d5017aa66935",
        "storage_key": "property/6767906449165638/019d20b0-481b-734f-b922-d5017aa66935.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a friendly game of billiards in our resident lounge, featuring a pool table and stunning views of the community pool.",
      "link": "",
      "alt_text": "Billiard table in a stylish lounge area with large windows overlooking the pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-e908-77ae-b38f-b23108525ea6.webp"
    },
    {
      "id": "custom_724c6d2c-aa29-4417-9669-b03fd63e987a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-4cc5-769a-bb4a-868fc88360b9.webp",
      "image_media": {
        "alt_text": "Modern apartment fitness center with cardio machines and weight/strength machines.",
        "public_id": "019d20b0-4cc5-769a-bb4a-868fc88360b9",
        "storage_key": "property/6767906449165638/019d20b0-4cc5-769a-bb4a-868fc88360b9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Spacious on-site gym for residents with cardio equipment and strength machines.",
      "link": "",
      "alt_text": "Modern apartment fitness center with cardio machines and weight/strength machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-fa21-714d-9c56-4f3659d7f7b3.webp"
    },
    {
      "id": "custom_9ebbfa5d-9723-47e0-935a-717d99aaf689",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-50cb-76cb-b9ef-cadbe9602ddb.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a marble island.",
        "public_id": "019d20b0-50cb-76cb-b9ef-cadbe9602ddb",
        "storage_key": "property/6767906449165638/019d20b0-50cb-76cb-b9ef-cadbe9602ddb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Contemporary apartment kitchen featuring dark cabinetry, stainless steel appliances, and a marble-topped island for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c187-71b8-81cc-b4686365fa65.webp"
    },
    {
      "id": "custom_6bfac1fe-b73a-429e-b7c5-edf618f815f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-562b-746e-b506-47deff15c2a8.webp",
      "image_media": {
        "alt_text": "Bright living room with large windows, neutral furnishings, and a green sectional sofa.",
        "public_id": "019d20b0-562b-746e-b506-47deff15c2a8",
        "storage_key": "property/6767906449165638/019d20b0-562b-746e-b506-47deff15c2a8.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area in a contemporary apartment with a sofa, chairs, and a dining nook.",
      "link": "",
      "alt_text": "Bright living room with large windows, neutral furnishings, and a green sectional sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c35d-7190-8f17-39142b6746b0.webp"
    },
    {
      "id": "custom_0b6f7485-b2ca-4984-98cb-47183828edb1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-5659-715e-8b09-c56599bc7c9c.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dark wood cabinets, marble countertop, mirror, and toilet.",
        "public_id": "019d20b0-5659-715e-8b09-c56599bc7c9c",
        "storage_key": "property/6767906449165638/019d20b0-5659-715e-8b09-c56599bc7c9c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom featuring a dark wood vanity, marble top, wall mirror, and compact layout.",
      "link": "",
      "alt_text": "Bathroom vanity with dark wood cabinets, marble countertop, mirror, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c29b-768f-a3b6-74864312c17f.webp"
    },
    {
      "id": "custom_8eed0d7f-19d2-4d45-9a2d-692424487a1a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-578a-7527-862c-db6f69e87ebb.webp",
      "image_media": {
        "alt_text": "Bedroom with dark wood bed frame, two matching nightstands, dresser, and window with blinds.",
        "public_id": "019d20b0-578a-7527-862c-db6f69e87ebb",
        "storage_key": "property/6767906449165638/019d20b0-578a-7527-862c-db6f69e87ebb.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Neutral-toned bedroom in a modern apartment with dark wood furniture and soft lighting.",
      "link": "",
      "alt_text": "Bedroom with dark wood bed frame, two matching nightstands, dresser, and window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c2ac-73ce-b444-31f9421f9d61.webp"
    },
    {
      "id": "custom_d6dbc62d-99f6-40ea-b9ea-692277a735b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-5c6e-767a-96e3-53fb02126fd4.webp",
      "image_media": {
        "alt_text": "Bright bedroom with a queen bed, two nightstands, and large windows with white curtains.",
        "public_id": "019d20b0-5c6e-767a-96e3-53fb02126fd4",
        "storage_key": "property/6767906449165638/019d20b0-5c6e-767a-96e3-53fb02126fd4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Contemporary bedroom with neutral tones, a plush bed, two nightstands, and ample natural light.",
      "link": "",
      "alt_text": "Bright bedroom with a queen bed, two nightstands, and large windows with white curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c2ed-713d-b2c0-126dc38118fd.webp"
    },
    {
      "id": "custom_f547f5c3-d7dc-4bbd-aab8-38273d6fec7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-5e9a-70a6-bd54-c80f58005efa.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a queen bed, upholstered headboard, dresser, and blue curtains.",
        "public_id": "019d20b0-5e9a-70a6-bd54-c80f58005efa",
        "storage_key": "property/6767906449165638/019d20b0-5e9a-70a6-bd54-c80f58005efa.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "A modern apartment bedroom featuring a neutral palette, matching dresser and side tables, and cozy decor.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a queen bed, upholstered headboard, dresser, and blue curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c2d3-738c-8296-8c908c892744.webp"
    },
    {
      "id": "custom_f26dc44c-b665-4696-a7ec-1e3d3656a161",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-6067-76b4-8ee5-7c511dce8812.webp",
      "image_media": {
        "alt_text": "Living room in an apartment with a sofa, white armchair, fireplace, mounted TV, and large windows.",
        "public_id": "019d20b0-6067-76b4-8ee5-7c511dce8812",
        "storage_key": "property/6767906449165638/019d20b0-6067-76b4-8ee5-7c511dce8812.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment living room with a fireplace, mounted TV, and abundant natural light.",
      "link": "",
      "alt_text": "Living room in an apartment with a sofa, white armchair, fireplace, mounted TV, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-c857-77d9-a8f5-ac41c72a23a8.webp"
    },
    {
      "id": "custom_35cf1c33-bcd2-4fa1-92a9-406ddb27889a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-65e7-71b1-b1eb-dbcfd24cee48.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, double sink, mirror, and decorative wall art.",
        "public_id": "019d20b0-65e7-71b1-b1eb-dbcfd24cee48",
        "storage_key": "property/6767906449165638/019d20b0-65e7-71b1-b1eb-dbcfd24cee48.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with marble countertop, double sink, large mirror, and framed wall art.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, double sink, mirror, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-cef4-724e-b181-428ef423f042.webp"
    },
    {
      "id": "custom_372fc2c6-ff6a-45af-9808-d4c8798b5160",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-6846-717e-bd61-0beab1e1f369.webp",
      "image_media": {
        "alt_text": "Bright living room with beige sofa, blue pillows, coffee table, and large front windows with blinds.",
        "public_id": "019d20b0-6846-717e-bd61-0beab1e1f369",
        "storage_key": "property/6767906449165638/019d20b0-6846-717e-bd61-0beab1e1f369.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment living area with a neutral palette, natural light from big windows, and coastal-inspired blue accents.",
      "link": "",
      "alt_text": "Bright living room with beige sofa, blue pillows, coffee table, and large front windows with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-d013-724b-92af-82eb594781e7.webp"
    },
    {
      "id": "custom_25e19ff8-436c-4fd3-9f89-f41ba9d1cf34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-691f-72bf-a6bb-8aeb025210f2.webp",
      "image_media": {
        "alt_text": "Bright apartment bathroom with tub/shower, toilet, and marble countertop.",
        "public_id": "019d20b0-691f-72bf-a6bb-8aeb025210f2",
        "storage_key": "property/6767906449165638/019d20b0-691f-72bf-a6bb-8aeb025210f2.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a marble vanity, large mirror, and coordinated towels.",
      "link": "",
      "alt_text": "Bright apartment bathroom with tub/shower, toilet, and marble countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-d153-7331-9658-684348926446.webp"
    },
    {
      "id": "custom_db71c760-99ce-4042-baae-d1efd423ec18",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-6cff-7569-acb2-11f8464474d0.webp",
      "image_media": {
        "alt_text": "Bedroom in an apartment with a queen bed, nightstand, dresser, and a window with curtains.",
        "public_id": "019d20b0-6cff-7569-acb2-11f8464474d0",
        "storage_key": "property/6767906449165638/019d20b0-6cff-7569-acb2-11f8464474d0.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright bedroom in a modern multifamily unit with neutral decor, wood-tone furniture, and a large window.",
      "link": "",
      "alt_text": "Bedroom in an apartment with a queen bed, nightstand, dresser, and a window with curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-d1be-776a-b608-248690df70ec.webp"
    },
    {
      "id": "custom_83546dde-972b-44d8-aa9e-28c282dc1295",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-728a-70e1-9984-3f30b68a2ad6.webp",
      "image_media": {
        "alt_text": "Bright apartment living room with brown leather sofa, cream chair, glass coffee table, and a desk by windows.",
        "public_id": "019d20b0-728a-70e1-9984-3f30b68a2ad6",
        "storage_key": "property/6767906449165638/019d20b0-728a-70e1-9984-3f30b68a2ad6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious, modern living area in a multifamily unit, featuring stylish seating and a work desk bathed in natural light.",
      "link": "",
      "alt_text": "Bright apartment living room with brown leather sofa, cream chair, glass coffee table, and a desk by windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-d484-72ea-b4db-c2622e5eeede.webp"
    },
    {
      "id": "custom_b25edb23-bc80-463f-8f2f-0f3623f641ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-7457-725b-882e-17c6995447b3.webp",
      "image_media": {
        "alt_text": "Bright home office with a wooden desk, tan chair, large windows with blinds, and a tall potted plant.",
        "public_id": "019d20b0-7457-725b-882e-17c6995447b3",
        "storage_key": "property/6767906449165638/019d20b0-7457-725b-882e-17c6995447b3.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright in-unit home office with a wooden desk, tan chair, lamp, and plant, showcasing a cozy workspace.",
      "link": "",
      "alt_text": "Bright home office with a wooden desk, tan chair, large windows with blinds, and a tall potted plant.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-d6b2-7408-a771-58f3de824e5d.webp"
    },
    {
      "id": "custom_08f121c7-201e-4121-8565-f0ad6dd99a5a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-74df-701e-b8b2-132c8fb72afa.webp",
      "image_media": {
        "alt_text": "Bedroom with gray wood bed, matching nightstands, blue accents, and a window with blue curtains.",
        "public_id": "019d20b0-74df-701e-b8b2-132c8fb72afa",
        "storage_key": "property/6767906449165638/019d20b0-74df-701e-b8b2-132c8fb72afa.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bedroom with gray furniture, blue accents, and ample natural light.",
      "link": "",
      "alt_text": "Bedroom with gray wood bed, matching nightstands, blue accents, and a window with blue curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-df8d-72ff-b430-142ad86434dd.webp"
    },
    {
      "id": "custom_67d17be3-809d-42ed-bce2-20d2bf576d34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-78a8-7559-83fb-cb09a7ca5c01.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with a large island, dark cabinets, and stainless steel appliances.",
        "public_id": "019d20b0-78a8-7559-83fb-cb09a7ca5c01",
        "storage_key": "property/6767906449165638/019d20b0-78a8-7559-83fb-cb09a7ca5c01.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen with a large island, pendant lighting, and stainless-steel appliances.",
      "link": "",
      "alt_text": "Modern apartment kitchen with a large island, dark cabinets, and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-def0-735b-9a6f-20d89d852eaf.webp"
    },
    {
      "id": "custom_cb6d9c7a-e366-4994-adf9-bf64aa7e4237",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-7f01-75a6-870b-492336cad0bd.webp",
      "image_media": {
        "alt_text": "Open-concept living room with a brown leather sofa, beige chairs, and a glass coffee table.",
        "public_id": "019d20b0-7f01-75a6-870b-492336cad0bd",
        "storage_key": "property/6767906449165638/019d20b0-7f01-75a6-870b-492336cad0bd.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious open-plan living area in a contemporary apartment with a leather sofa, neutral seating, and a kitchen bar.",
      "link": "",
      "alt_text": "Open-concept living room with a brown leather sofa, beige chairs, and a glass coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-e50c-7569-a1c8-2b558142f8a4.webp"
    },
    {
      "id": "custom_8ba45e5e-84cc-487c-bd90-88159b716d85",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-81ae-758a-9d07-c35288d42bd6.webp",
      "image_media": {
        "alt_text": "Bright living area with TV console, curved white coffee table, and open kitchen with bar seating.",
        "public_id": "019d20b0-81ae-758a-9d07-c35288d42bd6",
        "storage_key": "property/6767906449165638/019d20b0-81ae-758a-9d07-c35288d42bd6.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept apartment living area with a TV, seating, and a white kitchen with a breakfast bar.",
      "link": "",
      "alt_text": "Bright living area with TV console, curved white coffee table, and open kitchen with bar seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-eba2-77a7-8704-d31f62193dd8.webp"
    },
    {
      "id": "custom_947f9509-ab26-45b4-af22-d5d30abbd482",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-83d8-7570-bb8a-5a9b05bad5bc.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with dark wood cabinets, marble countertop, sink, mirror, and toilet.",
        "public_id": "019d20b0-83d8-7570-bb8a-5a9b05bad5bc",
        "storage_key": "property/6767906449165638/019d20b0-83d8-7570-bb8a-5a9b05bad5bc.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a marble countertop, single sink, and dark wood vanity.",
      "link": "",
      "alt_text": "Bathroom vanity with dark wood cabinets, marble countertop, sink, mirror, and toilet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-ebfe-7717-90a0-5dfb558abaf5.webp"
    },
    {
      "id": "custom_4c4eb52a-5ac6-44ac-bb96-3e881fbe1e8d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-851e-76e7-bec1-47f1292bc0da.webp",
      "image_media": {
        "alt_text": "Bathroom in an apartment with dark wood vanity, marble countertop, and shower curtain.",
        "public_id": "019d20b0-851e-76e7-bec1-47f1292bc0da",
        "storage_key": "property/6767906449165638/019d20b0-851e-76e7-bec1-47f1292bc0da.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with a dark wood vanity, marble counter, and contemporary decor.",
      "link": "",
      "alt_text": "Bathroom in an apartment with dark wood vanity, marble countertop, and shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-ec06-747f-928f-b8001d47b4e9.webp"
    },
    {
      "id": "custom_babd82e5-9b39-428b-97f1-655293f2620e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-8ae9-722d-a9b7-6256078ffe89.webp",
      "image_media": {
        "alt_text": "Living room in an apartment featuring a curved white sofa, floral curtains, two table lamps, and a round coffee table.",
        "public_id": "019d20b0-8ae9-722d-a9b7-6256078ffe89",
        "storage_key": "property/6767906449165638/019d20b0-8ae9-722d-a9b7-6256078ffe89.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Cozy apartment living room with a curved white sofa, floral curtains, lamps, and a round coffee table, showcasing modern decor.",
      "link": "",
      "alt_text": "Living room in an apartment featuring a curved white sofa, floral curtains, two table lamps, and a round coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-f1b5-7660-8f78-ac34c433052f.webp"
    },
    {
      "id": "custom_aa8a36df-3bcf-46e0-a8c0-07fe242f012b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-8b3e-719c-bb82-a621d9060382.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, mirror, and toilet in a modern apartment.",
        "public_id": "019d20b0-8b3e-719c-bb82-a621d9060382",
        "storage_key": "property/6767906449165638/019d20b0-8b3e-719c-bb82-a621d9060382.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright bathroom in a stylish apartment featuring a marble countertop, decorative accents, and ample storage.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, mirror, and toilet in a modern apartment.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-f3ee-76ea-b0e3-78b78bf68502.webp"
    },
    {
      "id": "custom_fa73560a-7085-422f-9c06-e6d78c655b60",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-904f-77fa-8e4f-db0575a6556d.webp",
      "image_media": {
        "alt_text": "Bright modern kitchen with white cabinets, stainless appliances, and a marble island with two beige stools.",
        "public_id": "019d20b0-904f-77fa-8e4f-db0575a6556d",
        "storage_key": "property/6767906449165638/019d20b0-904f-77fa-8e4f-db0575a6556d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Open-concept kitchen in a modern apartment with white cabinetry, stainless steel appliances, and a marble island.",
      "link": "",
      "alt_text": "Bright modern kitchen with white cabinets, stainless appliances, and a marble island with two beige stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-f92e-730e-a2d1-2c947de15813.webp"
    },
    {
      "id": "custom_58e44147-faea-4269-b9dc-b617700b1689",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-9462-71df-aaba-fd1cb47e492d.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with marble countertop, sink, mirror, and decorative accents.",
        "public_id": "019d20b0-9462-71df-aaba-fd1cb47e492d",
        "storage_key": "property/6767906449165638/019d20b0-9462-71df-aaba-fd1cb47e492d.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with marble countertop, vanity, and tasteful decor.",
      "link": "",
      "alt_text": "Bathroom vanity with marble countertop, sink, mirror, and decorative accents.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4a-fc73-769e-bd95-3151002cb893.webp"
    },
    {
      "id": "custom_f563c05e-1b35-4b28-867f-5f6aa8e1af34",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-9af9-7386-9e43-25b7652542a7.webp",
      "image_media": {
        "alt_text": "Bright apartment interior with a window-side desk, wall mural, and dining table.",
        "public_id": "019d20b0-9af9-7386-9e43-25b7652542a7",
        "storage_key": "property/6767906449165638/019d20b0-9af9-7386-9e43-25b7652542a7.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment featuring a bright workstation by windows, a wall mural, and a dining area.",
      "link": "",
      "alt_text": "Bright apartment interior with a window-side desk, wall mural, and dining table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-0293-7295-9bb9-558c8588db2f.webp"
    },
    {
      "id": "custom_cebe8420-52ed-4df5-b058-0a076a596837",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-9b45-74d8-8559-b4d996013361.webp",
      "image_media": {
        "alt_text": "Bedroom in a modern apartment with a large headboard, two nightstands, dresser, and pink curtains.",
        "public_id": "019d20b0-9b45-74d8-8559-b4d996013361",
        "storage_key": "property/6767906449165638/019d20b0-9b45-74d8-8559-b4d996013361.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright, contemporary bedroom in a furnished apartment with a tall upholstered headboard, matching nightstands, a dresser, and soft pink drapes.",
      "link": "",
      "alt_text": "Bedroom in a modern apartment with a large headboard, two nightstands, dresser, and pink curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-02b1-731e-aa58-1120d69cbb3d.webp"
    },
    {
      "id": "custom_076c14a1-4b30-49ab-9c3b-6c08d3d6d01c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-a21b-7663-b180-65ddee9af330.webp",
      "image_media": {
        "alt_text": "Bright modern apartment kitchen with white cabinets, stainless fridge, microwave, and marble island.",
        "public_id": "019d20b0-a21b-7663-b180-65ddee9af330",
        "storage_key": "property/6767906449165638/019d20b0-a21b-7663-b180-65ddee9af330.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Contemporary kitchen in a multifamily home featuring white cabinets, stainless appliances, and a marble-topped island.",
      "link": "",
      "alt_text": "Bright modern apartment kitchen with white cabinets, stainless fridge, microwave, and marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-053e-7719-84b5-1ca8480a0917.webp"
    },
    {
      "id": "custom_3fa05ab0-ca92-4373-a061-68da62ac3c72",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-a3fc-70a8-8bab-d47e53ff9739.webp",
      "image_media": {
        "alt_text": "Open-concept living area with sofa, chairs, coffee table, and a kitchen bar.",
        "public_id": "019d20b0-a3fc-70a8-8bab-d47e53ff9739",
        "storage_key": "property/6767906449165638/019d20b0-a3fc-70a8-8bab-d47e53ff9739.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright open-plan living space in a modern multifamily unit with a sofa, lounge chair, coffee table, dining area, and kitchen bar.",
      "link": "",
      "alt_text": "Open-concept living area with sofa, chairs, coffee table, and a kitchen bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-0680-77af-a6c3-18f9a47d6db1.webp"
    },
    {
      "id": "custom_7d0040c5-2e4c-4567-a620-5f3b7f93d1bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-aa0d-701b-9cc1-fdb48ed6a607.webp",
      "image_media": {
        "alt_text": "Bathroom with marble countertop, single sink, large mirror, and decorative plants.",
        "public_id": "019d20b0-aa0d-701b-9cc1-fdb48ed6a607",
        "storage_key": "property/6767906449165638/019d20b0-aa0d-701b-9cc1-fdb48ed6a607.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom with marble countertop, single sink, modern fixtures, and greenery.",
      "link": "",
      "alt_text": "Bathroom with marble countertop, single sink, large mirror, and decorative plants.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-0d2c-71ee-a48c-dbb4682d818f.webp"
    },
    {
      "id": "custom_b3264c94-c226-4740-b8ed-72f6134d65d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-ac94-740c-8fd9-a1965e65038c.webp",
      "image_media": {
        "alt_text": "Bright apartment bathroom with shower curtain, toilet, and double-sink vanity.",
        "public_id": "019d20b0-ac94-740c-8fd9-a1965e65038c",
        "storage_key": "property/6767906449165638/019d20b0-ac94-740c-8fd9-a1965e65038c.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with tub/shower, double vanity, and calm blue accents.",
      "link": "",
      "alt_text": "Bright apartment bathroom with shower curtain, toilet, and double-sink vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-0ea0-71b8-b7f0-0fa2c7904675.webp"
    },
    {
      "id": "custom_97070b76-d298-45b3-92d9-afbea157188e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d20b0-b85a-7713-881a-77a59ce50bfe.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinetry, stainless steel appliances, and a marble island.",
        "public_id": "019d20b0-b85a-7713-881a-77a59ce50bfe",
        "storage_key": "property/6767906449165638/019d20b0-b85a-7713-881a-77a59ce50bfe.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Spacious apartment kitchen featuring dark wood cabinets, stainless steel appliances, and a marble-topped island.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinetry, stainless steel appliances, and a marble island.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-179a-752c-ac15-7b9c9b569fc0.webp"
    },
    {
      "id": "custom_3ea81d23-08b4-4d95-bdb1-3f6419f4b0d1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/01a03a38-5de2-700d-8764-84b37d677c1c.webp",
      "image_media": {
        "alt_text": "Apartment buildings with a swimming pool and lounge area.",
        "public_id": "01a03a38-5de2-700d-8764-84b37d677c1c",
        "storage_key": "property/6767906449165638/01a03a38-5de2-700d-8764-84b37d677c1c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "View of apartment buildings featuring a swimming pool, lounge area, and manicured grounds, offering a glimpse into the community's amenities and modern living spaces.",
      "link": "",
      "alt_text": "Apartment buildings with a swimming pool and lounge area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_785445ef-4ff4-406a-bdd4-8c17e8ddbd25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ddf9-74ee-a15a-37355fddf172.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ddf9-74ee-a15a-37355fddf172",
        "storage_key": "property/6767906449165638/019d2709-ddf9-74ee-a15a-37355fddf172.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 21 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0f6c-7758-8fac-a25a29d5e28b",
        "storage_key": "property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_dee2b93c-7b72-4709-a929-d8700c1ce900",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ddfe-7529-a006-aaa9a86cdc05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ddfe-7529-a006-aaa9a86cdc05",
        "storage_key": "property/6767906449165638/019d2709-ddfe-7529-a006-aaa9a86cdc05.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0f6c-7758-8fac-a25a29d5e28b",
        "storage_key": "property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a8fed34e-1c28-4a5e-93f8-2d389566a90d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-de29-766b-b3d4-df8c22698fb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-de29-766b-b3d4-df8c22698fb5",
        "storage_key": "property/6767906449165638/019d2709-de29-766b-b3d4-df8c22698fb5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0f6c-7758-8fac-a25a29d5e28b",
        "storage_key": "property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_4a9ebe54-cc13-45fe-ab97-8fb1caed2809",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Tulsa Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Buffet, pizza and game chain featuring bumper cars and laser-tag attractions.",
      "poi_long_description": "People say this pizza restaurant offers a buffet with a wide variety of options, including pizza, hot dogs, fried chicken, and desserts, as well as rides, games, and attractions like go-karts and laser tag. They also highlight the fun experience, the friendly staff, and the good value for the price.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ddba-7657-9908-a40a5497e379.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ddba-7657-9908-a40a5497e379",
        "storage_key": "property/6767906449165638/019d2709-ddba-7657-9908-a40a5497e379.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-incredible-pizza-company",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0f6c-7758-8fac-a25a29d5e28b",
        "storage_key": "property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_f47d4acf-17d1-4a30-b946-33a53a7a99f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "1100 N 9th St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Laid-back chain counter-service spot specializing in hand-battered fried chicken tenders, fries and Texas toast.",
      "poi_long_description": "People say this fast food restaurant serves crispy chicken fingers, Texas toast, and fries. They highlight the tasty dipping sauce and the fresh, hot food. They also like the friendly staff and quick service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e1d8-7418-81a1-efba47db4194.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e1d8-7418-81a1-efba47db4194",
        "storage_key": "property/6767906449165638/019d2709-e1d8-7418-81a1-efba47db4194.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/broken-arrow/1100-n.-9th-st.",
      "poi_directions_map_url": "https://maps.google.com/?cid=6389543638470134900&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0621208",
      "poi_longitude": "-95.7802036",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-259-0213",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0f6c-7758-8fac-a25a29d5e28b",
        "storage_key": "property/6767906449165638/019d270a-0f6c-7758-8fac-a25a29d5e28b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLT-hA7eLtocRdIze_xU4rFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_3214c3a0-38ce-40c2-94fb-d4a21eab1281",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e26a-74cc-b38a-64527eeec06f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e26a-74cc-b38a-64527eeec06f",
        "storage_key": "property/6767906449165638/019d2709-e26a-74cc-b38a-64527eeec06f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0ff4-76ef-b0b7-755e7fa87344.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0ff4-76ef-b0b7-755e7fa87344",
        "storage_key": "property/6767906449165638/019d270a-0ff4-76ef-b0b7-755e7fa87344.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_4fb62c1e-4611-4569-9220-8b7f285c955c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e2db-7104-8244-cc81a7e1e8fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e2db-7104-8244-cc81a7e1e8fe",
        "storage_key": "property/6767906449165638/019d2709-e2db-7104-8244-cc81a7e1e8fe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 7 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0fec-716b-9cca-179c139338d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0fec-716b-9cca-179c139338d5",
        "storage_key": "property/6767906449165638/019d270a-0fec-716b-9cca-179c139338d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5a3ea180-0d81-405a-96bf-e6b36a1824b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e320-7789-ac1b-1c73d9b0b79d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e320-7789-ac1b-1c73d9b0b79d",
        "storage_key": "property/6767906449165638/019d2709-e320-7789-ac1b-1c73d9b0b79d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0fec-716b-9cca-179c139338d5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0fec-716b-9cca-179c139338d5",
        "storage_key": "property/6767906449165638/019d270a-0fec-716b-9cca-179c139338d5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_58cec458-e629-49a9-a623-b013c898913b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retail outlet for home improvement items, from tools and paint to lumber and garden supplies.",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e697-7503-b7a2-ae0f880cd932.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e697-7503-b7a2-ae0f880cd932",
        "storage_key": "property/6767906449165638/019d2709-e697-7503-b7a2-ae0f880cd932.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGMBGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0595916",
      "poi_longitude": "-95.866433",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0ff4-76ef-b0b7-755e7fa87344.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0ff4-76ef-b0b7-755e7fa87344",
        "storage_key": "property/6767906449165638/019d270a-0ff4-76ef-b0b7-755e7fa87344.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_a135e9fc-2568-48e2-9f96-a1b4953572b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "1900 E Hillside Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store has a wide variety of products and helpful staff. They also highlight the convenient self-checkout option.\n\nSome reviews mention the customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e6be-75bc-bef9-fa9fe37de699.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e6be-75bc-bef9-fa9fe37de699",
        "storage_key": "property/6767906449165638/019d2709-e6be-75bc-bef9-fa9fe37de699.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Broken-Arrow/1536?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-1536-_-na-_-0-_-0&y_source=1_MTE4NDM5OS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=12318214238171197715&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lowes-home-improvement",
      "poi_latitude": "36.065158",
      "poi_longitude": "-95.767607",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-355-4926",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0ff4-76ef-b0b7-755e7fa87344.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0ff4-76ef-b0b7-755e7fa87344",
        "storage_key": "property/6767906449165638/019d270a-0ff4-76ef-b0b7-755e7fa87344.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJg5dy-UuKtocRE3FavZUW86o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_7165bf04-87b3-41d9-acc9-666c32141883",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e7c5-701c-9ce5-ea558c702fa7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e7c5-701c-9ce5-ea558c702fa7",
        "storage_key": "property/6767906449165638/019d2709-e7c5-701c-9ce5-ea558c702fa7.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 14 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0fbb-716b-85ea-6a7533722ec0",
        "storage_key": "property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_7c9169e5-7fca-4ea8-bc5c-9a5c60e22faf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-e812-72e3-a226-2b0748a217ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-e812-72e3-a226-2b0748a217ea",
        "storage_key": "property/6767906449165638/019d2709-e812-72e3-a226-2b0748a217ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019376",
      "poi_longitude": "-95.7485342",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0fbb-716b-85ea-6a7533722ec0",
        "storage_key": "property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_ca0da896-fb1f-4eb8-b23f-21df2c03b03f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-eacd-74e1-aae7-33b651a85428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-eacd-74e1-aae7-33b651a85428",
        "storage_key": "property/6767906449165638/019d2709-eacd-74e1-aae7-33b651a85428.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0fbb-716b-85ea-6a7533722ec0",
        "storage_key": "property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_a6f6778d-d5a0-4b23-be3a-6f796d8fbd92",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "TCC Southeast Library",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St Building 7, Room 7200, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ebe6-734b-bad5-d1f6136e0a87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ebe6-734b-bad5-d1f6136e0a87",
        "storage_key": "property/6767906449165638/019d2709-ebe6-734b-bad5-d1f6136e0a87.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://library.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341227726380407188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tcc-southeast-library",
      "poi_latitude": "36.0433144",
      "poi_longitude": "-95.8632335",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 9 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-595-7701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1368-729f-874e-8c1ce12a5b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1368-729f-874e-8c1ce12a5b07",
        "storage_key": "property/6767906449165638/019d270a-1368-729f-874e-8c1ce12a5b07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdNrW1mNtocRlBlTtNNrg48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_0cc50b40-a2bb-4fc9-a337-bd355fbce898",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Broken Arrow Library",
      "poi_type": "Education",
      "poi_address": "300 W Broadway Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Relaxed spot featuring summer reading programs, plus helpful staff and books.",
      "poi_long_description": "People say this public library has helpful staff who can assist with checking out books, placing holds, and finding sister locations, as well as apps for readers and a pamphlet of activities and new releases. They also highlight the library's clean and cozy atmosphere with plenty of spots to sit and work or read.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ecec-742e-bb48-a023c8574ad2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ecec-742e-bb48-a023c8574ad2",
        "storage_key": "property/6767906449165638/019d2709-ecec-742e-bb48-a023c8574ad2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.tulsalibrary.org/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=10472699381773494596&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "broken-arrow-library",
      "poi_latitude": "36.0529865",
      "poi_longitude": "-95.7936926",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-0fbb-716b-85ea-6a7533722ec0",
        "storage_key": "property/6767906449165638/019d270a-0fbb-716b-85ea-6a7533722ec0.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFxNF-OmLtocRROkP2pmAVpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_6d1dc650-155a-4efd-8be0-d629be48c915",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Bixby Public Schools Football Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Riverview &, E Stadium Rd, Bixby, OK 74008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-eccf-710d-abf4-500da4715fdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-eccf-710d-abf4-500da4715fdb",
        "storage_key": "property/6767906449165638/019d2709-eccf-710d-abf4-500da4715fdb.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14748620811824529784&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "bixby-public-schools-football-stadium",
      "poi_latitude": "35.9359397",
      "poi_longitude": "-95.8774673",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-13a4-758a-96f0-f89204dd4de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-13a4-758a-96f0-f89204dd4de8",
        "storage_key": "property/6767906449165638/019d270a-13a4-758a-96f0-f89204dd4de8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ669iX12FtocReAG8n3ygrcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_096c39f0-68ec-4634-86ef-cb3eedccb515",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "The Museum Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "400 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Small, locally focused museum highlighting the history, art and genealogy of Broken Arrow.",
      "poi_long_description": "Museum displaying local & regional history via artifacts, special exhibits & various events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-efc5-759a-abce-413d52135e1f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-efc5-759a-abce-413d52135e1f",
        "storage_key": "property/6767906449165638/019d2709-efc5-759a-abce-413d52135e1f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.brokenarrowmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16351764218256934691&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-museum-broken-arrow",
      "poi_latitude": "36.0491954",
      "poi_longitude": "-95.7911106",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-258-2616",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1415-71cc-9a7d-b85fc366c1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1415-71cc-9a7d-b85fc366c1e0",
        "storage_key": "property/6767906449165638/019d270a-1415-71cc-9a7d-b85fc366c1e0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJMxSi48KLtocRI8cl0Osi7eI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_983e3804-a01e-4772-a5dc-49af2f5b7645",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Rose District Splash Pad",
      "poi_type": "Entertainment",
      "poi_address": "416 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Popular destination featuring a fountain and splash pad where kids can play in the water and adults can relax.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f0ec-734c-9fcb-6630bc9d8350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f0ec-734c-9fcb-6630bc9d8350",
        "storage_key": "property/6767906449165638/019d2709-f0ec-734c-9fcb-6630bc9d8350.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://rosedistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7184917167890550428&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rose-district-splash-pad",
      "poi_latitude": "36.0488437",
      "poi_longitude": "-95.7910116",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-259-7007",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT0CU3cKLtocRnM64zBj0tWM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "water_park"
    },
    {
      "id": "custom_bd63fd33-0abb-4a30-982e-d42ca8dbc7d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Spartan Stadium",
      "poi_type": "Entertainment",
      "poi_address": "Riverview &, E Stadium Rd, Bixby, OK 74008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f195-77ad-b405-c086c8e3e741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f195-77ad-b405-c086c8e3e741",
        "storage_key": "property/6767906449165638/019d2709-f195-77ad-b405-c086c8e3e741.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16095621502748277725&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "spartan-stadium",
      "poi_latitude": "35.9359342",
      "poi_longitude": "-95.8773434",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 53 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-13a4-758a-96f0-f89204dd4de8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-13a4-758a-96f0-f89204dd4de8",
        "storage_key": "property/6767906449165638/019d270a-13a4-758a-96f0-f89204dd4de8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJl9ipoaWFtocR3TtzfnoiX98",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_d1fd1054-d0ff-4349-84c9-365ece29ada6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Military History Museum",
      "poi_type": "Entertainment",
      "poi_address": "112 N Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Tours and exhibits of military history that feature donated artifacts and memorabilia.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f1e7-77e2-b2fe-7a73d782771c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f1e7-77e2-b2fe-7a73d782771c",
        "storage_key": "property/6767906449165638/019d2709-f1e7-77e2-b2fe-7a73d782771c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.okmhc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13208418279094056410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "military-history-museum",
      "poi_latitude": "36.0528999",
      "poi_longitude": "-95.7910559",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-794-2712",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1415-71cc-9a7d-b85fc366c1e0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1415-71cc-9a7d-b85fc366c1e0",
        "storage_key": "property/6767906449165638/019d270a-1415-71cc-9a7d-b85fc366c1e0.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJLetKKsKLtocR2nUtknG6Tbc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_290eccd2-f950-44cd-a9c8-5ca5898702e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f43f-76be-a2dd-89d231d38877.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f43f-76be-a2dd-89d231d38877",
        "storage_key": "property/6767906449165638/019d2709-f43f-76be-a2dd-89d231d38877.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d200e38c-6398-4bbc-b66d-e82b8b7960ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f636-7428-bce1-855bce4279c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f636-7428-bce1-855bce4279c0",
        "storage_key": "property/6767906449165638/019d2709-f636-7428-bce1-855bce4279c0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3eb383b8-8de2-46be-a96c-a16a9885cee7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f615-72ee-8d1c-71d97f506b24.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f615-72ee-8d1c-71d97f506b24",
        "storage_key": "property/6767906449165638/019d2709-f615-72ee-8d1c-71d97f506b24.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_cfab6021-e2d5-49c8-8d4d-ca023048889a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f65c-77a9-aa4e-7690413a6371.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f65c-77a9-aa4e-7690413a6371",
        "storage_key": "property/6767906449165638/019d2709-f65c-77a9-aa4e-7690413a6371.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ebabd311-185a-4742-a5f8-6cbc3d936b8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-f90c-7619-a506-19e63d73d06e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-f90c-7619-a506-19e63d73d06e",
        "storage_key": "property/6767906449165638/019d2709-f90c-7619-a506-19e63d73d06e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b17219a2-ff2e-4b14-adfa-8f6a6241aef8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "8722 E 71st St Suite 872, Tulsa, OK 74133, USA",
      "poi_short_description": "Chains such as this one sell cosmetics, fragrances and makeup in stores and online, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-fa75-76cf-8854-2b24a83acdc8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-fa75-76cf-8854-2b24a83acdc8",
        "storage_key": "property/6767906449165638/019d2709-fa75-76cf-8854-2b24a83acdc8.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-1113",
      "poi_directions_map_url": "https://maps.google.com/?cid=9163598623872888103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.059026",
      "poi_longitude": "-95.8790444",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-250-9053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUwgJEyMtocRJ60zyGWkK38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_0ab64623-c4fc-4f4e-976c-0590f7ad9951",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "R.C. Dickenson Family YMCA",
      "poi_type": "Health and Wellness",
      "poi_address": "8501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Classes, pool and gym with friendly staff plus a variety of exercise machines.",
      "poi_long_description": "People say this gym offers a wide variety of cardio and weightlifting equipment, as well as a play and learn area for children. They highlight the clean facilities and affordable prices. They also like the friendly and professional staff, and the calm and welcoming atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-fb2f-761e-ba24-ecafadc85956.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-fb2f-761e-ba24-ecafadc85956",
        "storage_key": "property/6767906449165638/019d2709-fb2f-761e-ba24-ecafadc85956.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.ymcatulsa.org/dickenson/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3422791293805268507&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rc-dickenson-family-ymca",
      "poi_latitude": "36.0410595",
      "poi_longitude": "-95.8496234",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 50 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-872-9622",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJb0w56y6MtocRGw6QB4wygC8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_74c1aa1e-003d-4c28-be67-4e776ba0c27b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Umac Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Gym featuring basketball and volleyball courts, plus facilities for wrestling, cheerleading, and other competitions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-fb2e-72fd-9cec-49b2b0f8075d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-fb2e-72fd-9cec-49b2b0f8075d",
        "storage_key": "property/6767906449165638/019d2709-fb2e-72fd-9cec-49b2b0f8075d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unionps.org/activities/umac",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233318345147314712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umac-tulsa",
      "poi_latitude": "36.0641918",
      "poi_longitude": "-95.8694283",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo05n3rqNtocRGHK6l7oLKe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_fe34fb20-bd55-4996-a1e3-b21963b4aae8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Miami Nails",
      "poi_type": "Health and Wellness",
      "poi_address": "2409 W Kenosha St #161, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-fdc5-728f-a4dc-92f203e878cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-fdc5-728f-a4dc-92f203e878cf",
        "storage_key": "property/6767906449165638/019d2709-fdc5-728f-a4dc-92f203e878cf.webp",
        "width": 900,
        "height": 900
      },
      "poi_business_url": "https://miaminailsbrokenarrow.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18392555638477026749&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "miami-nails",
      "poi_latitude": "36.0596694",
      "poi_longitude": "-95.8197326",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-251-2525",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdYxGgXSMtocRvfUHv-d7P_8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nail_salon"
    },
    {
      "id": "custom_377d0584-97f8-4536-ba64-74462c46b56d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ff53-72db-9439-bd8935038dc2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ff53-72db-9439-bd8935038dc2",
        "storage_key": "property/6767906449165638/019d2709-ff53-72db-9439-bd8935038dc2.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1796-706d-b84d-3aed623d8d40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1796-706d-b84d-3aed623d8d40",
        "storage_key": "property/6767906449165638/019d270a-1796-706d-b84d-3aed623d8d40.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_f05d3d2a-903d-4d82-9c72-bcae58300dbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Saint Francis Hospital South",
      "poi_type": "Health and Wellness",
      "poi_address": "10501 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d2709-ffe6-71a9-a360-385e0672977e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2709-ffe6-71a9-a360-385e0672977e",
        "storage_key": "property/6767906449165638/019d2709-ffe6-71a9-a360-385e0672977e.webp",
        "width": 350,
        "height": 350
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital-south",
      "poi_directions_map_url": "https://maps.google.com/?cid=18406794313894727694&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital-south",
      "poi_latitude": "36.0333434",
      "poi_longitude": "-95.8576667",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-307-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1796-706d-b84d-3aed623d8d40.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1796-706d-b84d-3aed623d8d40",
        "storage_key": "property/6767906449165638/019d270a-1796-706d-b84d-3aed623d8d40.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJKXaxi3-OtocRDhBgtecRcv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_d330cc2c-0a02-486a-9784-5cf7784f4518",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0036-750a-a4c8-1272477f7006.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-0036-750a-a4c8-1272477f7006",
        "storage_key": "property/6767906449165638/019d270a-0036-750a-a4c8-1272477f7006.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 13 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1755-7049-8360-ca644e224f9a",
        "storage_key": "property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_20c1598f-f5cf-4894-84ee-fc03887ff55c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0226-744e-a7a8-9874883992f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-0226-744e-a7a8-9874883992f9",
        "storage_key": "property/6767906449165638/019d270a-0226-744e-a7a8-9874883992f9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1755-7049-8360-ca644e224f9a",
        "storage_key": "property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_84022867-3c2b-4310-b229-e1c905abb6f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-04fd-777c-9666-bcc7f917c741.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-04fd-777c-9666-bcc7f917c741",
        "storage_key": "property/6767906449165638/019d270a-04fd-777c-9666-bcc7f917c741.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1755-7049-8360-ca644e224f9a",
        "storage_key": "property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ee023328-910e-4850-9354-874467f95855",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-04f0-73ba-b189-f3226cb64eae.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-04f0-73ba-b189-f3226cb64eae",
        "storage_key": "property/6767906449165638/019d270a-04f0-73ba-b189-f3226cb64eae.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1755-7049-8360-ca644e224f9a",
        "storage_key": "property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4ac62846-669e-4a2b-af95-06bae7389b2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Ray Harral Nature Park & Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7101 S 3rd St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Dog-friendly nature park featuring a suspension bridge and an educational center.",
      "poi_long_description": "Visitors say this nature park offers stroller-friendly walking trails and a well-maintained nature center with hands-on activities for children, including sensory items, books, and information about local wildlife. They also highlight the peaceful atmosphere, abundance of shade, and dog-friendly policy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0600-7768-8100-dcf6051397e3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-0600-7768-8100-dcf6051397e3",
        "storage_key": "property/6767906449165638/019d270a-0600-7768-8100-dcf6051397e3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.facebook.com/RayHarralNatureCenter/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3946947640467703348&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ray-harral-nature-park--center",
      "poi_latitude": "35.984247",
      "poi_longitude": "-95.786704",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-615-6099",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1755-7049-8360-ca644e224f9a",
        "storage_key": "property/6767906449165638/019d270a-1755-7049-8360-ca644e224f9a.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_BQieWItocRNMYkmfdfxjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c50ae432-b844-4bc5-baad-c0e3acf7257c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "City of Broken Arrow",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 S 1st St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-06de-76b6-82c5-d542db701240.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-06de-76b6-82c5-d542db701240",
        "storage_key": "property/6767906449165638/019d270a-06de-76b6-82c5-d542db701240.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981682047998685423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-broken-arrow",
      "poi_latitude": "36.0510555",
      "poi_longitude": "-95.7899817",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1368-729f-874e-8c1ce12a5b07.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1368-729f-874e-8c1ce12a5b07",
        "storage_key": "property/6767906449165638/019d270a-1368-729f-874e-8c1ce12a5b07.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQP1vMOLtocR7_CiSld8R6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_d84640f1-5a1f-4d8c-b613-8c6b8b5400ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0989-7378-9ae6-ca4701e2223d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-0989-7378-9ae6-ca4701e2223d",
        "storage_key": "property/6767906449165638/019d270a-0989-7378-9ae6-ca4701e2223d.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a8c32009-f125-47d3-a7ec-67366bb3b946",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Casino Cash Trac",
      "poi_type": "Major Employers & Offices",
      "poi_address": "7835 E 106th St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.casinocashtrac.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13720834206770318126&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "casino-cash-trac",
      "poi_latitude": "36.0107418",
      "poi_longitude": "-95.8887703",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-794-8255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpwaDBRiOtocRLsuS1AMyar4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_bb031905-bc6a-4a53-b4dc-de0f106ae7ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "The Galley",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12626 S Memorial Dr, Bixby, OK 74008, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0a0a-7126-84ae-e5898e0d2cf4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-0a0a-7126-84ae-e5898e0d2cf4",
        "storage_key": "property/6767906449165638/019d270a-0a0a-7126-84ae-e5898e0d2cf4.webp",
        "width": 1280,
        "height": 865
      },
      "poi_business_url": "https://thegalley.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17164344617237820771&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-galley",
      "poi_latitude": "35.9803984",
      "poi_longitude": "-95.8873715",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 800-375-4255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4Z49t8-PtocRYzXZIH0ANO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_0d80c225-c794-429d-954b-f0f0e2484147",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Jack Wills Companies - Warehouse and Corporate Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5891 S Garnett Rd, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-0b60-753e-a8d6-62aa7bd1daf6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d270a-0b60-753e-a8d6-62aa7bd1daf6",
        "storage_key": "property/6767906449165638/019d270a-0b60-753e-a8d6-62aa7bd1daf6.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=7832107266597974639&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "jack-wills-companies---warehouse-and-corporate-offices",
      "poi_latitude": "36.0774642",
      "poi_longitude": "-95.8493322",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-459-3730",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d270a-1435-75e6-a141-bc61bfca16cc",
        "storage_key": "property/6767906449165638/019d270a-1435-75e6-a141-bc61bfca16cc.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgUX4BlaMtocRb_JTDBA8sWw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a41d8036-52d0-4ad2-9ff3-ae359f83c08e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Broken Arrow Public Schools",
      "poi_type": "Education",
      "poi_address": "701 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-80d9-7683-a8a4-2b8a802da487.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-80d9-7683-a8a4-2b8a802da487",
        "storage_key": "property/6767906449165638/019d7913-80d9-7683-a8a4-2b8a802da487.webp",
        "width": 800,
        "height": 463
      },
      "poi_business_url": "http://www.baschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10674098885329665355&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "broken-arrow-public-schools",
      "poi_latitude": "36.0459159",
      "poi_longitude": "-95.7901585",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-259-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df",
        "storage_key": "property/6767906449165638/019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJZy0oKMKLtocRS7135WEEIpQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_2bd7ba61-db72-43eb-b250-fef2f9d25243",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Summit Christian Academy",
      "poi_type": "Education",
      "poi_address": "200 E Broadway Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-8103-7058-a17e-f86fb9147ecf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8103-7058-a17e-f86fb9147ecf",
        "storage_key": "property/6767906449165638/019d7913-8103-7058-a17e-f86fb9147ecf.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.summit.school/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411921446695056607&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "summit-christian-academy",
      "poi_latitude": "36.0527427",
      "poi_longitude": "-95.788597",
      "poi_miles_from_property": "6.2 mi",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-251-1997",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df",
        "storage_key": "property/6767906449165638/019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKULs3MOLtocR37SzEX-3ILo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_21bdd233-8837-4937-8f82-7399e24bd139",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-80cc-776a-bb21-22dc29df1ee4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-80cc-776a-bb21-22dc29df1ee4",
        "storage_key": "property/6767906449165638/019d7913-80cc-776a-bb21-22dc29df1ee4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "17.2 mi",
      "poi_walking_minutes": "6 hours 22 mins",
      "poi_biking_minutes": "2 hours 1 min",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df",
        "storage_key": "property/6767906449165638/019cfb4b-9e3c-753b-9ed0-3eebf0e9e6df.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8aab46c5-ee2b-4b11-a170-8f5bcfc1f911",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Oklahoma Joe's Barbecue",
      "poi_type": "Restaurants",
      "poi_address": "6175 E 61st St, Tulsa, OK 74136, USA",
      "poi_short_description": "Relaxed BBQ pit stop for slabs of ribs, pulled pork sandwiches, meat by the pound & sides.",
      "poi_long_description": "People say this barbecue restaurant serves tasty ribs, pulled pork, and burnt ends. They also highlight the fast service, friendly staff, and clean, happy atmosphere.\n\nOther reviews mention the brisket can be dry.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-849d-70da-bb28-c2b55b47716e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-849d-70da-bb28-c2b55b47716e",
        "storage_key": "property/6767906449165638/019d7913-849d-70da-bb28-c2b55b47716e.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://okjoes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10293820666620048956&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-joe-s-barbecue",
      "poi_latitude": "36.075939",
      "poi_longitude": "-95.906952",
      "poi_miles_from_property": "10.0 mi",
      "poi_walking_minutes": "3 hours 42 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-894-4447",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e31-75b4-b015-4e769e6e09cf",
        "storage_key": "property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ92aoYeStocRPHZ2d1v_2o4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_1ef404b7-e7ff-45b1-bad2-c99adc85bccb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Rustic Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "210 S Main St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Rustic steakhouse in the Rose District Plaza serving up choice cuts and other hearty fare, plus cocktails.",
      "poi_long_description": "People say this chophouse restaurant serves delicious steaks, crab cakes, and lobster bisque. They also highlight the cozy and elegant atmosphere, and the friendly and attentive service.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-8ce9-73fb-a31d-f1106104dc3a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8ce9-73fb-a31d-f1106104dc3a",
        "storage_key": "property/6767906449165638/019d7913-8ce9-73fb-a31d-f1106104dc3a.webp",
        "width": 1000,
        "height": 562
      },
      "poi_business_url": "https://www.rusticchophouseba.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15410778395433896171&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "rustic-chophouse",
      "poi_latitude": "36.0509556",
      "poi_longitude": "-95.7910163",
      "poi_miles_from_property": "5.9 mi",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-355-0814",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e31-75b4-b015-4e769e6e09cf",
        "storage_key": "property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB0Fbt_-LtocR6wgaBE0V3tU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_541fce4f-fd61-49a6-9f23-f1679ad6e9f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Ted's Café Escondido",
      "poi_type": "Restaurants",
      "poi_address": "501 W Albany Dr, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Local chain serving traditional Mexican fare in a relaxed space with traditional touches.",
      "poi_long_description": "People say this Mexican restaurant serves amazing nachos, fresh tortillas, and complimentary salsa, cheese dip, and sopapillas. They also highlight the attentive service, friendly staff, and clean atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-8d51-750a-b7ba-36e9949626b1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-8d51-750a-b7ba-36e9949626b1",
        "storage_key": "property/6767906449165638/019d7913-8d51-750a-b7ba-36e9949626b1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://tedscafe.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11328924120112948582&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ted-s-caf-escondido",
      "poi_latitude": "36.0749427",
      "poi_longitude": "-95.7968651",
      "poi_miles_from_property": "7.3 mi",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-254-8337",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e31-75b4-b015-4e769e6e09cf",
        "storage_key": "property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytG_2uMtocRZuWvynZsOJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_91bd024d-c3ad-4040-9d9e-f810b970c9c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "All About Cha Cafe & Restaurant - Broken Arrow",
      "poi_type": "Restaurants",
      "poi_address": "820 N Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Cozy spot for breakfast, bubble tea, and coffee, plus Korean fare such as bento boxes and bulgogi wraps.",
      "poi_long_description": "People say this bubble tea store offers a wide variety of teas, as well as food options like sushi and cheesecake. They highlight the reasonable prices and the relaxed, peaceful atmosphere, perfect for chatting or meetings. They also like the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-924e-764a-847c-d3a2309e1dcb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-924e-764a-847c-d3a2309e1dcb",
        "storage_key": "property/6767906449165638/019d7913-924e-764a-847c-d3a2309e1dcb.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://allaboutchaba.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=17532261031567663262&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "all-about-cha-cafe-restaurant-broken-arrow",
      "poi_latitude": "36.0593669",
      "poi_longitude": "-95.8159067",
      "poi_miles_from_property": "5.3 mi",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-940-7171",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e31-75b4-b015-4e769e6e09cf",
        "storage_key": "property/6767906449165638/019cfb4b-9e31-75b4-b015-4e769e6e09cf.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJl2p8zOaNtocRnqADsIQaT_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_36e06ad7-6f85-49f7-aff9-6bd797398f66",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Bass Pro Shops",
      "poi_type": "Shopping & Retail",
      "poi_address": "101 Bass Pro Drive, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain known for its large, wilderness-themed stores & wide array of hunting, fishing & outdoor gear.",
      "poi_long_description": "People say this sporting goods store offers a wide selection of hunting, fishing, and outdoor gear, as well as clothing and home decor. They highlight the fun and festive atmosphere, especially during the holidays, and the interesting attractions like the fish tanks and trout pond. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-943c-7084-ab79-9a86282f4f0e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-943c-7084-ab79-9a86282f4f0e",
        "storage_key": "property/6767906449165638/019d7913-943c-7084-ab79-9a86282f4f0e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.basspro.com/us/ok/broken-arrow/101-bass-pro-dr.html?y_source=1_MzAxMTUyNC03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=14650999968817088325&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "bass-pro-shops",
      "poi_latitude": "36.0709381",
      "poi_longitude": "-95.7921204",
      "poi_miles_from_property": "7.6 mi",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-355-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e",
        "storage_key": "property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJhSZm66KLtocRRQea6djOUss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_27e02e1f-d1e6-4c5b-9989-7e058e5a75a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Harbor Freight",
      "poi_type": "Shopping & Retail",
      "poi_address": "3601 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_long_description": "Retail chain carrying a wide range of tools, hardware & other products for the home, garden & car.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-a065-762a-8794-b6599cd8b2e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a065-762a-8794-b6599cd8b2e4",
        "storage_key": "property/6767906449165638/019d7913-a065-762a-8794-b6599cd8b2e4.webp",
        "width": 1280,
        "height": 580
      },
      "poi_business_url": "https://www.harborfreight.com/storelocator/3601-south-elm-place-broken-arrow-74011?number=462",
      "poi_directions_map_url": "https://maps.google.com/?cid=15854953648466520317&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "harbor-freight",
      "poi_latitude": "36.0168456",
      "poi_longitude": "-95.7957945",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-451-4963",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e",
        "storage_key": "property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJAeuU8ECJtocR_WghE1ccCNw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hardware_store"
    },
    {
      "id": "custom_0c7bef1e-3e57-444d-9cf3-e95b7ee5a4a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6310 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Wide selection of items including electronics, home furniture, clothing, toys, and baby gear.",
      "poi_long_description": "People say this department store offers a wide variety of products and is clean and organized.\n\nOther reviews mention the service can be slow and the staff can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-a191-72e1-9ce6-8f377f119b17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a191-72e1-9ce6-8f377f119b17",
        "storage_key": "property/6767906449165638/019d7913-a191-72e1-9ce6-8f377f119b17.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/3295-broken-arrow-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13803958368995643297&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.9918222",
      "poi_longitude": "-95.8008118",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-455-4354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e",
        "storage_key": "property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJc78tJ9-ItocRoQ9EBgCDkb8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_61e61ce5-b26a-498f-8c5a-0ea312fb3a8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "525 W Tucson St, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Shoppers say this supermarket offers a good selection of groceries at affordable prices, with fresh produce and high-quality store brands. They also highlight the clean and well-organized store, and friendly and helpful employees.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-a6db-72aa-b54d-f1fe73328fc6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a6db-72aa-b54d-f1fe73328fc6",
        "storage_key": "property/6767906449165638/019d7913-a6db-72aa-b54d-f1fe73328fc6.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://info.aldi.us/stores/l/ok/broken-arrow/525-w-tucson-st/f257",
      "poi_directions_map_url": "https://maps.google.com/?cid=3072427690360315802&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "35.987763",
      "poi_longitude": "-95.7957967",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e2c-7248-95f1-392bed4de83d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e2c-7248-95f1-392bed4de83d",
        "storage_key": "property/6767906449165638/019cfb4b-9e2c-7248-95f1-392bed4de83d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLa6sGUGJtocRmh8AurR0oyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_9b3d94e8-8267-4827-bb01-2970c39781e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Eastside Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Strip malls featuring familiar restaurants, shops and a Target store.",
      "poi_long_description": "People say this shopping center offers great steaks. They also highlight the reasonable prices and early bird specials.\n\nOther reviews mention the service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-a81a-718e-abb5-3cdfabd7d42d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-a81a-718e-abb5-3cdfabd7d42d",
        "storage_key": "property/6767906449165638/019d7913-a81a-718e-abb5-3cdfabd7d42d.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=420103559678602685&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "eastside-market",
      "poi_latitude": "36.0610807",
      "poi_longitude": "-95.8531648",
      "poi_miles_from_property": "6.3 mi",
      "poi_walking_minutes": "2 hours 19 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-461-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e",
        "storage_key": "property/6767906449165638/019cfb4b-9e39-73c9-90ab-2a6d1cc92f6e.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ9w-qcEyMtocRvS2FM_aB1AU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_82abe988-4dfd-403a-a702-d8984e3ebfea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Lit'l Links Golf Club",
      "poi_type": "Entertainment",
      "poi_address": "11915 S 129th E Ave, Broken Arrow, OK 74011, USA",
      "poi_short_description": "false",
      "poi_long_description": "People say this golf course offers a fun par 3 course and a driving range.\n\nOther reviews mention the greens can be poorly maintained and the course can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-adbf-7127-87bc-c16ed7183100.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-adbf-7127-87bc-c16ed7183100",
        "storage_key": "property/6767906449165638/019d7913-adbf-7127-87bc-c16ed7183100.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.litllinks.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7657517502459899847&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lit-l-links-golf-club",
      "poi_latitude": "35.99057",
      "poi_longitude": "-95.832756",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-481-3673",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-bcbb-72fc-b04c-12dc8da46276.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7913-bcbb-72fc-b04c-12dc8da46276",
        "storage_key": "property/6767906449165638/019d7913-bcbb-72fc-b04c-12dc8da46276.webp",
        "width": 132,
        "height": 192
      },
      "poi_google_place_id": "ChIJgYlFuCCPtocRx29145j3RGo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "golf_course"
    },
    {
      "id": "custom_2ce6d1a1-0174-4242-8ef2-49694a82d66d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Thousands of aquatic species, plus a walk-through tunnel & chances to touch sharks & stingrays.",
      "poi_long_description": "People say this aquarium offers a wide variety of aquatic creatures, including sharks, sea turtles, and jellyfish, as well as some land animals. They highlight the interactive experiences, such as touch tanks and feeding opportunities, and the well-maintained exhibits. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-ab90-7184-bc53-b1fbe2ce8630.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-ab90-7184-bc53-b1fbe2ce8630",
        "storage_key": "property/6767906449165638/019d7913-ab90-7184-bc53-b1fbe2ce8630.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "1 hour 3 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e3c-753b-9ed0-40c6c8e3f55c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e3c-753b-9ed0-40c6c8e3f55c",
        "storage_key": "property/6767906449165638/019cfb4b-9e3c-753b-9ed0-40c6c8e3f55c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_ae5c37dc-a303-4dfb-90e2-29f9193bd229",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d7913-af3d-717f-98dd-7b8fb4683d55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7913-af3d-717f-98dd-7b8fb4683d55",
        "storage_key": "property/6767906449165638/019d7913-af3d-717f-98dd-7b8fb4683d55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "10.4 mi",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 5 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-9e3c-753b-9ed0-40c6c8e3f55c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb4b-9e3c-753b-9ed0-40c6c8e3f55c",
        "storage_key": "property/6767906449165638/019cfb4b-9e3c-753b-9ed0-40c6c8e3f55c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_d7ef43b1-fbc3-4b37-9824-b520ccba01d9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "poi_name": "Shiloh’s",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "shiloh-s",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_d838f1bca2cbeab039ea8037",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_67f9d079c481495ea2a0d676",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_f8ed1bb0f50d6fea20651a56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e9828dac528d1270bae3f8ae",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_a0e329afaec9356d7b4ee1bc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    },
    {
      "id": "ec_3ff17c14cddb545c4d082799",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_adbc0cef-5fa9-42ae-bb95-13e2c3005355",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "rating": "5.0",
      "name": "Ash Han",
      "text": "So let me start with I've been here since December 2024 and I've enjoyed everything! The staff is beyond amazing and some are familiar faces from my many years with Case Properties.\n\nI love the atmosphere, the respectfulness of the staff all the way through the fellow neighbors, it definitely has a community vibe with a touch of city / country atmosphere which I enjoy.\n\nAll in all I give a 8 out of 10 ratings, reasoning for my love and skills in interior design, drafting and home inspection* (still in school)* 😅 the contractor definitely needs a slap on the hand for making a C grade uh-ohs 🤭 as I did in class.\n\nOther than that it's a 5 star community in reviews to me, and 10* stars in personal ratings outside of my Inspector stand point.\n\nAlso much love and respect to the maintenance team as well for all the hard work and always being an amazing helping hand, I am thankful for the whole team at Trails at Aspen and I look forward to continuing my support forwards.",
      "date": "2025-09-11",
      "title": ""
    },
    {
      "id": "custom_2cbe7168-c83c-4d8b-acd7-e7150b4ccc88",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "rating": "5.0",
      "name": "Steven Higgins",
      "text": "Wonderful staff from the ladies in the office to the maintenance guys. Complex is well taken care of and clean. If there are any issues the work orders are completed in a quick and timely manner. Very professional and courteous. Residents are also very friendly. Always say hi when in passing. I highly recommend the trails at aspen creek to anyone or family of any age looking for a permanent or temporary resident. Very pet friendly with 2 dog parks and amenities that are safe and accessible.",
      "date": "2025-08-19",
      "title": ""
    },
    {
      "id": "custom_1bb04edf-1546-4b94-b91c-60c48a8628bc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "rating": "5.0",
      "name": "David Pannebaker",
      "text": "We were with Case and Associate properties several years ago and they were great then. We lived at Park of Mission Hills the first time and now here at Aspan Trails. The experience hasn't changed at all. The management team they have put together here is exceptional. We had a few things that needed to be done in the apartment, and they attended to it promptly and without question. I seriously hope they don't change the management team here when the get the apartment filled. Jasmine the Assistant Manager is great and if she doesn't know she will take it right to Jasmine the Manager and it gets taken care of. Glad we moved back into a Case Property.",
      "date": "2025-08-29",
      "title": ""
    },
    {
      "id": "custom_4bd1dcbf-b587-4644-abea-716e3a22ed3f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "rating": "5.0",
      "name": "Alexis Rice",
      "text": "Jazmin was amazing. I told her my situation with my previous apartment and she was completely emphatic and got us approved and moved in within a week! Was very communicative and helpful through the whole process. 10/10 love love love the apartments and management even more!",
      "date": "2025-07-23",
      "title": ""
    },
    {
      "id": "custom_77013989-065f-41b1-8631-1b70f81cefed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "rating": "5.0",
      "name": "Sydnee Manyik",
      "text": "These brand new apartments are incredible! They are everything you need and they are worth the money!\nI have had no issues with the complex and the staff is great! Jasmin is great at what she does and is super friendly! 100% recommend living here!",
      "date": "2025-09-20",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5d069d58-6a9c-42bd-ba09-162e3a51e9be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4c-a60a-776c-9509-66291c0a41cf.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 tour of a modern apartment kitchen with island and seating.",
        "public_id": "019cfb4c-a60a-776c-9509-66291c0a41cf",
        "storage_key": "property/6767906449165638/019cfb4c-a60a-776c-9509-66291c0a41cf.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Trails at Aspen Creek Apartments Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=682fcf74dc82e87df1d57aa0"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-7b3d-768a-9423-4cb5cc0b301a",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "trails-at-aspen-creek",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638"
    },
    {
      "lead_collector_id": "019cf79e-7bb0-7568-a05f-1def81d2f6f6",
      "lead_source": "LANDING_PAGE",
      "name": "trails-at-aspen-creek",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-broken-arrow",
      "search_query": "apartments with in-unit laundry Broken Arrow",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Trails at Aspen Creek. Situated in Broken Arrow, your ideal home awaits with top-tier amenities.",
      "page_copy": "Imagine the ease of life with in-unit laundry at the Trails at Aspen Creek in Broken Arrow. Our community, nestled in the serene ambiance of South Tulsa, offers a modern living experience with the convenience that today's residents seek. Explore our spacious one, two, and three-bedroom floor plans, each thoughtfully designed to suit your lifestyle and include this sought-after amenity.\n\nAt Trails at Aspen Creek, enjoy more than just an apartment—it’s a community enhanced by premium features such as a refreshing pool, well-equipped fitness center, and expansive dog park. Your daily life becomes seamless with access to cable-ready homes and generous pantry space. Live comfortably and conveniently in a home that meets all your needs in an idyllic Broken Arrow setting.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Laundry Apartments - Broken Arrow",
      "seo_description": "Enjoy in-unit laundry at Trails at Aspen Creek in Broken Arrow. Experience modern living with top amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "pool-equipped-apartments-74011",
      "search_query": "pool-equipped apartments in 74011",
      "category": "Amenity",
      "h1_title": "Pool-Equipped Apartments in 74011",
      "h2_subtitle": "Cool off at Trails at Aspen Creek’s pool-equipped apartments in Broken Arrow, 74011. Dive into relaxation and unmatched comfort.",
      "page_copy": "Experience the ultimate in leisure at Trails at Aspen Creek, offering pool-equipped apartments in the vibrant 74011 area of Broken Arrow. Our picturesque community cradled in nature invites you to unwind by our serene pool, perfect for escaping the Oklahoma heat. Residents can enjoy spacious one, two, or three-bedroom layouts fitted with all modern conveniences.\n\nOur Broken Arrow community delivers more than just a refreshing pool. Stay connected at the business center, maintain an active lifestyle in our fitness center, and let your furry friends enjoy the agility of our dog park. Every apartment is cable-ready, features a private balcony, and includes a pantry—all designed to enhance the resident experience. Embrace luxury and comfort at Trails of Aspen Creek.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pool-Equipped Apartments - Broken Arrow, 74011",
      "seo_description": "Relax at the pool-equipped Trails at Aspen Creek in Broken Arrow, 74011. Enjoy top amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "dog-friendly-apartments-south-tulsa",
      "search_query": "dog-friendly apartments South Tulsa",
      "category": "Amenity",
      "h1_title": "Dog-Friendly Apartments in South Tulsa",
      "h2_subtitle": "Welcome to dog-friendly living at Trails at Aspen Creek in South Tulsa. Our community offers a dog park and amenities perfect for you and your pet.",
      "page_copy": "Discover the ideal dog-friendly apartments in South Tulsa at Trails at Aspen Creek. Designed with pet lovers in mind, our community boasts a dedicated dog park, allowing your furry friend plenty of space to run and play. Choose from spacious one, two, or three-bedroom floor plans that offer modern comfort and style.\n\nLocated in the scenic area of South Tulsa, Trails at Aspen Creek combines the tranquility of nature with the convenience of nearby amenities. Our residents enjoy a serene pool, a well-equipped fitness center, and units that come cable-ready with private balconies and pantries. Experience the perfect blend of nature and modern living in a community where both you and your pet can thrive.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog-Friendly Apartments - South Tulsa",
      "seo_description": "Find dog-friendly living at Trails at Aspen Creek in South Tulsa. Enjoy amenities like a dog park in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "modern-apartments-ac-broken-arrow",
      "search_query": "modern apartments with air conditioning Broken Arrow",
      "category": "Amenity",
      "h1_title": "Modern Apartments with A/C in Broken Arrow",
      "h2_subtitle": "Stay cool at Trails at Aspen Creek, where modern apartments with air conditioning await you in Broken Arrow.",
      "page_copy": "Embrace comfort and style at Trails at Aspen Creek, offering modern apartments with air conditioning in Broken Arrow. Nestled in the scenic surroundings of South Tulsa, our community is an oasis of tranquility paired with contemporary conveniences. Choose from our expansive one, two, or three-bedroom layouts designed to meet your every need.\n\nBeyond climate-controlled living, Trails at Aspen Creek offers a host of amenities including a refreshing pool, a well-equipped fitness center, and a dog park your pets will adore. Each unit is cable-ready and features a private balcony and a spacious pantry. Discover comfortable and convenient living in a vibrant Broken Arrow setting where your lifestyle gets the upgrade you've been searching for.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Apartments with A/C - Broken Arrow",
      "seo_description": "Discover modern apartments with air conditioning at Trails at Aspen Creek in Broken Arrow. Enjoy top amenities in a serene location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "apartment-with-dishwasher-broken-arrow-ok",
      "search_query": "apartment with dishwasher Broken Arrow OK",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwasher in Broken Arrow, OK",
      "h2_subtitle": "Enjoy the convenience of a dishwasher at Trails at Aspen Creek in Broken Arrow, OK. Our apartments are designed to simplify your life.",
      "page_copy": "Welcome to the convenience-filled lifestyle at Trails at Aspen Creek, featuring apartments with a dishwasher in the heart of Broken Arrow, OK. Our community is tailored to meet the needs of modern residents, providing lush surroundings in the South Tulsa area for a peaceful yet connected lifestyle.\n\nChoose from spacious one, two, or three-bedroom floor plans, each equipped with amenities that make everyday living a breeze, including a dishwasher to simplify mealtime cleanup. Beyond your home, enjoy our business center, serene pool, fitness center, and vast dog park, all designed to create the perfect balance of relaxation and activity. Upgrade your living experience at Trails at Aspen Creek, where convenience and comfort are always at hand.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwasher - Broken Arrow, OK",
      "seo_description": "Find apartments with a dishwasher at Trails at Aspen Creek in Broken Arrow, OK. Enjoy a convenient and modern living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "1-bedroom-apartments-broken-arrow-ok",
      "search_query": "1 bedroom apartments broken arrow ok",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Broken Arrow, OK",
      "h2_subtitle": "Explore spacious 1 bedroom apartments at Trails at Aspen Creek in Broken Arrow, OK. Modern living awaits you here.",
      "page_copy": "Discover the ideal one-bedroom apartments in Broken Arrow, OK, at Trails at Aspen Creek. Our community offers a perfect blend of comfort and style, nestled in South Tulsa's tranquil landscape. Enjoy the modern features and thoughtful layout of our one-bedroom units, designed to cater to your lifestyle needs.\n\nTrails at Aspen Creek not only offers cozy interiors but also a wealth of community amenities. Relax by our serene pool, stay fit at the well-equipped fitness center, or let your furry friend roam in the dog park. With a cable-ready setup and amenities like a private balcony and pantry, our one-bedroom apartments provide the perfect living space in Broken Arrow, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments - Broken Arrow, OK",
      "seo_description": "Find spacious 1 bedroom apartments at Trails at Aspen Creek in Broken Arrow, OK. Experience comfort and modern amenities in a serene setting.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-south-tulsa",
      "search_query": "2 bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover the spacious 2 bedroom apartments at Trails at Aspen Creek in South Tulsa. Modern amenities await you.",
      "page_copy": "Welcome to the spacious 2 bedroom apartments in South Tulsa at Trails at Aspen Creek. These well-designed homes offer the perfect blend of comfort and functionality, ideal for anyone looking to enjoy modern living amidst serene surroundings. Each unit features premium amenities, making our community a perfect place to call home.\n\nLocated in the beautiful area of Broken Arrow, our 2 bedroom apartments provide ample living space alongside an array of amenities. Take advantage of our refreshing pool, state-of-the-art fitness center, and engaging dog park. With cable-ready apartments featuring a private balcony and a convenient pantry, Trails at Aspen Creek ensures a perfect balance of luxury and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments - South Tulsa",
      "seo_description": "Explore spacious 2 bedroom apartments at Trails at Aspen Creek in South Tulsa. Enjoy premium living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165638",
      "source": "generator",
      "page_item_url": "3-bedroom-floor-plans-near-74011",
      "search_query": "3 bedroom floor plans near 74011",
      "category": "Floorplan",
      "h1_title": "3 Bedroom Floor Plans Near 74011",
      "h2_subtitle": "Discover our expansive 3 bedroom floor plans at Trails at Aspen Creek. Located conveniently near the 74011 area, your ideal home awaits.",
      "page_copy": "Experience the luxury of spacious living with our 3 bedroom floor plans near the 74011 area at Trails at Aspen Creek. These thoughtfully designed layouts provide generous space, perfect for families or those needing extra room. Nestled in the serene environment of Broken Arrow, our community combines style with comfort.\n\nOur 3 bedroom floor plans are complemented by top-notch amenities like a serene pool, modern fitness center, and a welcoming dog park. Each apartment is cable ready and features a private balcony and a pantry, enhancing your everyday living. Make Trails at Aspen Creek your great escape in South Tulsa, where home meets affordability and convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
      "featured_image_media": {
        "alt_text": "Bright living and dining area with white curved sofa and a round dining table.",
        "public_id": "019cfb4b-7be8-763a-a212-904f1b482324",
        "storage_key": "property/6767906449165638/019cfb4b-7be8-763a-a212-904f1b482324.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "3 Bedroom Floor Plans Near 74011",
      "seo_description": "Explore spacious 3 bedroom floor plans at Trails at Aspen Creek near the 74011 area. Enjoy comfort and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5222"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-CYQS3S5CV1"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151223"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/trails-at-aspen-creek/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PHXL4D8M"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d1bda-9b7c-75d9-be95-47ef89cd0afc.webp"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "9042d9fb-741f-464a-a4d5-c9180d585252"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "877-812-5761"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "6734df013e95f50202967abd"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IlRscTVFSEtuU1NNRzZNY2xIemhkdWc9PSIsInZhbHVlIjoiVHRJZ0I4b081RGtReW5vM0tGTGQ2QT09IiwibWFjIjoiZDVmNGNkMjIzYmY5NjllZmI5ZWExMzgyNjJkMzJiYTFjYTMwNjUzN2NiYzE2MTc4NDVlNzIyYTk1ZTY3OTA3NyJ9"
    }
  ],
  "custom_qb_id": "5222",
  "custom_ga4_id": "G-CYQS3S5CV1",
  "custom_repli_id": "10041151223",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/trails-at-aspen-creek/register/",
  "custom_google_gtm_id": "GTM-PHXL4D8M",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449165638/019d1bda-9b7c-75d9-be95-47ef89cd0afc.webp",
  "custom_rentgrata_property_id": "9042d9fb-741f-464a-a4d5-c9180d585252",
  "custom_ppc_tracking_phone_number": "877-812-5761",
  "custom_residentboost_apartment_id": "6734df013e95f50202967abd",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IlRscTVFSEtuU1NNRzZNY2xIemhkdWc9PSIsInZhbHVlIjoiVHRJZ0I4b081RGtReW5vM0tGTGQ2QT09IiwibWFjIjoiZDVmNGNkMjIzYmY5NjllZmI5ZWExMzgyNjJkMzJiYTFjYTMwNjUzN2NiYzE2MTc4NDVlNzIyYTk1ZTY3OTA3NyJ9"
};

export const generatedAt = '2026-08-27T21:35:37.771Z';
